import { z } from 'zod'
import {
  coachingAuthLogoutResponseSchema,
  coachingAuthOtpSendResponseSchema,
  coachingAuthOtpVerifyResponseSchema,
} from './coaching-boundaries'
import { coachingUserRoleSchema } from './coaching-shell-observability'

export {
  coachingAuthLogoutResponseSchema,
  coachingAuthOtpSendResponseSchema,
  coachingAuthOtpVerifyResponseSchema,
}
export type {
  CoachingAuthLogoutResponse,
  CoachingAuthOtpSendResponse,
  CoachingAuthOtpVerifyResponse,
} from './coaching-boundaries'

export const COACHING_AUTH_CONTRACT_VERSION = '1.0.0' as const

export const coachingAuthMembershipSchema = z.object({
  orgId: z.string().min(1),
  role: z.string().nullable(),
  status: z.string().nullable(),
  orgName: z.string().nullable(),
  coachingRole: coachingUserRoleSchema.nullable(),
}).passthrough()
export type CoachingAuthMembership = z.infer<typeof coachingAuthMembershipSchema>

export const coachingAuthSessionResponseSchema = z.object({
  contract_version: z.literal(COACHING_AUTH_CONTRACT_VERSION).or(z.string().min(1)),
  isPlatformAdmin: z.boolean(),
  user: z.object({
    id: z.string().min(1),
    email: z.string().min(1),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    status: z.string().nullable(),
  }).passthrough(),
  memberships: z.array(coachingAuthMembershipSchema),
}).passthrough()
export type CoachingAuthSessionResponse = z.infer<typeof coachingAuthSessionResponseSchema>
